export const OFFICE_ADDRESS = "304/305, D'Gold House, Dnyaneshwar Paduka Chowk, FC Rd, Shivajinagar, Pune, Maharashtra 411005, India";

export const PHONE_PRIMARY = { display: '+91 89895 50909', href: 'tel:+918989550909' };
export const PHONE_SECONDARY = { display: '+91 89846 16204', href: 'tel:+918984616204' };

export const VISA_NAV = [
  { key: 'usa', label: 'USA' },
  { key: 'uk', label: 'UK' },
  { key: 'germany', label: 'Germany' },
  { key: 'ireland', label: 'Ireland' },
  { key: 'australia', label: 'Australia' },
  { key: 'canada', label: 'Canada' },
  { key: 'newzealand', label: 'New Zealand' },
  { key: 'france', label: 'France' },
  { key: 'taiwan', label: 'Taiwan' }
];

export const STUDY_DESTINATION_NAV = [
  { key: 'usa', name: 'USA' },
  { key: 'uk', name: 'UK' },
  { key: 'germany', name: 'Germany' },
  { key: 'france', name: 'France' },
  { key: 'ireland', name: 'Ireland' },
  { key: 'taiwan', name: 'Taiwan' },
  { key: 'italy', name: 'Italy' },
  { key: 'canada', name: 'Canada' },
  { key: 'australia', name: 'Australia' },
  { key: 'japan', name: 'Japan' },
  { key: 'newzealand', name: 'New Zealand' },
  { key: 'netherlands', name: 'Netherlands' }
];
